import { get, isNil } from "lodash-es";
import axios from "axios";

export default {
  namespaced: true,
  state: () => ({
    nombre: "",
    apellido: "",
    nombreWeb: "",
    telCelular: "",
    emailFacturacion: null,
    emailGerencia: "",
    nombreUsuario: "",
    password: "",

    idCobranzaLugarDePago: null,
    empresaPropia: null,
    idClienteReferenciador: null,

    tipoTarjeta: null,
    nroTarjeta: null,

    codigoRapipago: null,
  }),
  mutations: {
    resetForm(state) {
      state.nombre = "";
      state.apellido = "";
      state.nombreWeb = "";
      state.telCelular = "";
      state.emailFacturacion = null;
      state.emailGerencia = "";
      state.nombreUsuario = "";
      state.password = "";

      state.idCobranzaLugarDePago = null;
      state.empresaPropia = null;
      state.idClienteReferenciador = null;
      state.nroTarjeta = null;
      state.codigoRapipago = null;
      state.tipoTarjeta = null;
    },
    setNombre(state, payload) {
      state.nombre = payload;
    },
    setApellido(state, payload) {
      state.apellido = payload;
    },
    setNombreWeb(state, payload) {
      state.nombreWeb = payload;
    },
    setTelCelular(state, payload) {
      state.telCelular = payload;
    },
    setEmailFacturacion(state, payload) {
      state.emailFacturacion = payload;
    },
    setEmailGerencia(state, payload) {
      state.emailGerencia = payload;
    },
    setNombreUsuario(state, payload) {
      state.nombreUsuario = payload;
    },
    setPassword(state, payload) {
      state.password = payload;
    },
    setIdCobranzaLugarDePago(state, payload) {
      state.idCobranzaLugarDePago = payload;
    },
    setEmpresaPropia(state, payload) {
      state.empresaPropia = payload;
    },
    setIdCliente(state, payload) {
      state.idCliente = payload;
    },
    setIdClienteReferenciador(state, payload) {
      state.idClienteReferenciador = payload;
    },
    setTipoTarjeta(state, payload) {
      state.tipoTarjeta = payload;
    },
    setNroTarjeta(state, payload) {
      state.nroTarjeta = payload;
    },
    setCodigoRapipago(state, payload) {
      state.codigoRapipago = payload;
    },
  },
  actions: {
    async submit(context) {
      try {
        if (
          isNil(context.state.nroTarjeta) &&
          !isNil(context.state.tipoTarjeta)
        ) {
          return {
            ok: false,
            message: "Por favor, ingrese un número de tarjeta",
          };
        }
        const resp = await axios.post("/execute", {
          method: "CLI.CrearClienteConCobranza",
          parameters: [
            { name: "nombre", value: context.state.nombre },
            { name: "apellido", value: context.state.apellido },
            { name: "nombre_web", value: context.state.nombreWeb },
            {
              name: "cel_personal",
              value: get(context, "state.telCelular", null),
            },
            {
              name: "email_facturacion",
              value: get(context, "state.emailFacturacion", null),
            },
            { name: "email_gerencia", value: context.state.emailGerencia },
            { name: "nombre_usuario", value: context.state.nombreUsuario },
            { name: "password", value: context.state.password },
            {
              name: "id_cobranza_lugarPago",
              value: get(
                context,
                "state.idCobranzaLugarDePago.id_cobranza_lugarPago",
                null,
              ),
            },
            {
              name: "id_clienteReferenciador",
              value: get(
                context,
                "state.idClienteReferenciador.id_cliente",
                null,
              ),
            },
            {
              name: "nro_tarjeta",
              value: !isNil(context.state.tipoTarjeta)
                ? context.state.nroTarjeta.replace(/\s+/g, "")
                : null,
            },
            {
              name: "tipo_tarjeta",
              value: context.state.tipoTarjeta,
            },
            {
              name: "codigo_rapipago",
              value: get(context, "state.codigoRapipago", null),
            },
          ],
        });
        return resp.data;
      } catch (e) {
        return { ok: false, message: e.toString() };
      }
    },
  },
};
